import { makeStyles } from "@mui/styles"

const useStyles = makeStyles(() => ({
  rowChecked: {
    borderRadius: 8,
    cursor: "pointer",
    backgroundColor: "#ececec",
    "& #kebab": {
      color: "#263057",
    },
  },
  row: {
    borderRadius: 8,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#ececec",
      "& #kebab": {
        color: "#263057",
      },
    },
  },
  itemCheck: {
    height: 44,
    fontFamily: "Roboto",
    fontWeight: "bold",
    color: "#6e7a76",
    width: "5%",
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
    textAlign: "center",
  },
  hoverButton: {
    color: "#706E6F",
    "&:hover": {
      color: "#026873",
    },
  },
  hoverButtonDelete: {
    color: "#706E6F",
    "&:hover": {
      color: "#AD0707",
    },
  },
  itemStatusActive: {
    fontFamily: "Roboto",
    fontWeight: "bold",
    color: "green",
    textAlign: "center",
  },
  itemStatusInactive: {
    fontFamily: "Roboto",
    fontWeight: "bold",
    color: "red",
    textAlign: "center",
  },
  itemStatusWaiting: {
    fontFamily: "Roboto",
    fontWeight: "bold",
    color: "blue",
    textAlign: "center",
  },

  itemName: {
    height: 44,
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "bold",
    color: "#6e7a76",
    textAlign: "center",
    "&:hover": {
      backgroundColor: "#ececec",
    },
    textOverflow: "ellipsis",
    width: "25%",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
  itemIcon: {
    height: 44,
    width: "10%",
    color: "#6e7a76",
    textAlign: "center",
    "&:hover": {
      color: "#026873",
    },
  },

  itemLastName: {
    height: 44,
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "bold",
    color: "#6e7a76",
    textAlign: "center",
    "&:hover": {
      backgroundColor: "#ececec",
    },
    textOverflow: "ellipsis",
    width: "15%",
    overflow: "hidden",
    whiteSpace: "nowrap",
    "@media all and (max-width: 900px)": {
      display: "none",
    },
  },
  itemTypeUser: {
    height: 44,
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "bold",
    color: "#6e7a76",
    textAlign: "center",
    "&:hover": {
      backgroundColor: "#ececec",
    },
    textOverflow: "ellipsis",
    width: "15%",
    overflow: "hidden",
    whiteSpace: "nowrap",
    "@media all and (max-width: 900px)": {
      display: "none",
    },
  },
  itemEmail: {
    height: 44,
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "bold",
    color: "#6e7a76",
    textAlign: "center",
    "&:hover": {
      backgroundColor: "#ececec",
    },
    textOverflow: "ellipsis",
    width: "25%",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
  itemKebab: {
    height: 44,
    fontFamily: "Roboto",
    fontWeight: "bold",
    color: "#2C3532",
    width: "5%",
    textAlign: "start",
    borderTopRightRadius: 8,
    borderBottomRightRadius: 8,
    "&:hover": {
      backgroundColor: "#ececec",
    },
  },
  kebab: {
    color: "#B3B3B3",
  },
}))

export default useStyles
